module.exports = __webpack_public_path__ + "img/users.a7667074.svg";